import api from "@/lib/api";

const toBytes = (s) => {
  const t = s.replace(/-/g, "+").replace(/_/g, "/");
  const pad = t + "=".repeat((4 - (t.length % 4)) % 4);
  return Uint8Array.from(atob(pad), (c) => c.charCodeAt(0));
};

const toB64 = (buf) => {
  const a = new Uint8Array(buf);
  let s = "";
  a.forEach((v) => { s += String.fromCharCode(v); });
  return btoa(s).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export async function isBiometricAvailable() {
  if (!window.PublicKeyCredential) return false;
  try {
    return await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
  } catch {
    return false;
  }
}

export async function enrollBiometric(deviceName) {
  const { data: o } = await api.post("/webauthn/register/options");
  o.challenge = toBytes(o.challenge);
  o.user.id = toBytes(o.user.id);
  (o.excludeCredentials || []).forEach((c) => { c.id = toBytes(c.id); });
  const cred = await navigator.credentials.create({ publicKey: o });
  const r = cred.response;
  const credential = {
    id: cred.id,
    rawId: toB64(cred.rawId),
    type: cred.type,
    response: {
      clientDataJSON: toB64(r.clientDataJSON),
      attestationObject: toB64(r.attestationObject),
      transports: r.getTransports ? r.getTransports() : [],
    },
    clientExtensionResults: cred.getClientExtensionResults(),
    authenticatorAttachment: cred.authenticatorAttachment,
  };
  await api.post("/webauthn/register/verify", { credential, device_name: deviceName || "" });
  return true;
}

export async function loginBiometric(email) {
  const { data: o } = await api.post("/webauthn/login/options", { email });
  const userId = o.user_id;
  o.challenge = toBytes(o.challenge);
  (o.allowCredentials || []).forEach((c) => { c.id = toBytes(c.id); });
  const cred = await navigator.credentials.get({ publicKey: o });
  const r = cred.response;
  const credential = {
    id: cred.id,
    rawId: toB64(cred.rawId),
    type: cred.type,
    response: {
      clientDataJSON: toB64(r.clientDataJSON),
      authenticatorData: toB64(r.authenticatorData),
      signature: toB64(r.signature),
      userHandle: r.userHandle ? toB64(r.userHandle) : null,
    },
    clientExtensionResults: cred.getClientExtensionResults(),
    authenticatorAttachment: cred.authenticatorAttachment,
  };
  const { data } = await api.post("/webauthn/login/verify", { user_id: userId, credential });
  return data;
}
